import { readRemaining1u8soafhjma7y as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.l5g().v5i(), $completion));
  return SavedHttpCall().e5k(_this__u8e3s4.g5g_1, _this__u8e3s4.g5i(), _this__u8e3s4.l5g(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      static e5k(client, request, response, responseBody) {
        var $this = this.f5i(client);
        $this.c5k_1 = responseBody;
        $this.i5g_1 = new (SavedHttpRequest())($this, request);
        $this.j5g_1 = new (SavedHttpResponse())($this, $this.c5k_1, response);
        checkContentLength(contentLength(response), fromInt($this.c5k_1.length), request.o5i());
        $this.d5k_1 = true;
        return $this;
      }
      i5i() {
        return this.d5k_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.f5k_1 = origin;
        this.g5k_1 = call;
      }
      n5i() {
        return this.g5k_1;
      }
      xv() {
        return this.f5k_1.xv();
      }
      o5i() {
        return this.f5k_1.o5i();
      }
      p5i() {
        return this.f5k_1.p5i();
      }
      h5i() {
        return this.f5k_1.h5i();
      }
      j2o() {
        return this.f5k_1.j2o();
      }
      f50() {
        return this.f5k_1.f50();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.h5k_1 = call;
        this.i5k_1 = body;
        this.j5k_1 = origin.w5i();
        this.k5k_1 = origin.x5i();
        this.l5k_1 = origin.y5i();
        this.m5k_1 = origin.z5i();
        this.n5k_1 = origin.f50();
        this.o5k_1 = origin.xv();
      }
      n5i() {
        return this.h5k_1;
      }
      w5i() {
        return this.j5k_1;
      }
      x5i() {
        return this.k5k_1;
      }
      y5i() {
        return this.l5k_1;
      }
      z5i() {
        return this.m5k_1;
      }
      f50() {
        return this.n5k_1;
      }
      xv() {
        return this.o5k_1;
      }
      v5i() {
        return ByteReadChannel(this.i5k_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save1y71vsgu0wj47,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
